import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=60854bbe"
import script from "./SupplierList.vue?vue&type=script&lang=js"
export * from "./SupplierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60854bbe')) {
      api.createRecord('60854bbe', component.options)
    } else {
      api.reload('60854bbe', component.options)
    }
    module.hot.accept("./SupplierList.vue?vue&type=template&id=60854bbe", function () {
      api.rerender('60854bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supplier/components/SupplierList.vue"
export default component.exports